import Requests from "@/services/Requests";

const state = {
  paymentSettings: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allPaymentSettings: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  paymentSettingById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of paymentSettings based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter paymentSettings by. Defaults to 0.
   * @return {Array} An array of paymentSettings filtered by the given page number. If page is 0, returns all paymentSettings.
   */
  getPaymentSettings:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.paymentSettings.data
        : state.paymentSettings.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllPaymentSettings: (state) => state.allPaymentSettings.data,
  getPaymentSettingStatus: (state) => state.paymentSettings.status,
  getPaymentSettingCount: (state) => state.paymentSettings.count,
  getPaymentSettingPage: (state) => state.paymentSettings.page,
  getPaymentSettingsLoading: (state) =>
    state.paymentSettings.status === "loading",
  getPaymentSettingById: (state) => (id) =>
    state.paymentSettingById.data.find((d) => d.id === id) || {},
};
const mutations = {
  /**
   * Updates the status of the paymentSetting in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the paymentSetting.
   */
  SET_PAYMENT_SETTING_STATUS(state, payload) {
    console.log(state.paymentSettings, "status: ", payload);
    state.paymentSettings.status = payload;
  },
  /**
   * Sets the paymentSettings and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of paymentSettings.
   * @param {number} payload.count - The total count of paymentSettings.
   */
  SET_PAYMENT_SETTINGS(state, payload) {
    state.paymentSettings.data = payload.items;
    state.paymentSettings.count = payload.count;
  },
  /**
   * Sets the paymentSettings and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of paymentSettings.
   * @param {number} payload.count - The total count of paymentSettings.
   */
  SET_ALL_PAYMENT_SETTINGS(state, payload) {
    console.log("SET_ALL_PAYMENT_SETTINGS", payload);
    state.allPaymentSettings.data = payload.items;
    state.allPaymentSettings.count = payload.count;
  },
  /**
   * Updates the status of the update paymentSetting in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the paymentSetting.
   */
  SET_UPDATE_PAYMENT_SETTING_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an paymentSetting object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated paymentSetting object.
   * @return {void}
   */
  SET_UPDATE_PAYMENT_SETTING(state, payload) {
    const index = state.paymentSettings.data.findIndex(
      (d) => d.id === payload.id
    );
    const paymentSetting = state.paymentSettings.data[index];
    state.paymentSettings.data[index] = { ...paymentSetting, ...payload };
  },
  SET_CREATE_PAYMENT_SETTING_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new paymentSetting to the list of paymentSettings in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The paymentSetting object to be added.
   * @return {void}
   */
  SET_CREATE_PAYMENT_SETTING(state, payload) {
    state.paymentSettings.data.push(payload);
  },
  /**
   * Updates the status of the delete paymentSetting in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the paymentSetting.
   */
  SET_DELETE_PAYMENT_SETTING_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an paymentSetting from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the paymentSetting ID to be deleted.
   * @param {number} payload.id - The ID of the paymentSetting to be deleted.
   * @return {void}
   */
  SET_DELETE_PAYMENT_SETTING(state, payload) {
    state.paymentSettings.data = state.paymentSettings.data.filter(
      (d) => d.id !== payload.id
    );
  },
  SET_PAYMENT_SETTING_BY_ID_STATUS(state, payload) {
    state.paymentSettingById.status = payload;
  },
  SET_PAYMENT_SETTING_BY_ID(state, payload) {
    state.paymentSettingById.data.push(payload);
  },
};

const actions = {
  /**
   * Retrieves a list of paymentSettings based on the provided payload.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the query parameters.
   * @return {Promise<void>}
   */
  async getPaymentSettings({ commit, state }, payload) {
    const status = state.paymentSettings.status;
    commit("SET_PAYMENT_SETTING_STATUS", "loading");
    const response = await Requests.PaymentSetting.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_PAYMENT_SETTINGS", {
        items: response.data.map((item) => ({
          ...item,
          page: payload.query.page,
        })),
        count: response.data.count,
      });
      console.log(payload, "payload", payload.initial, "inital");
      if (status === "unitiliazed")
        commit("SET_ALL_PAYMENT_SETTINGS", {
          items: response.data.map((item) => ({
            ...item,
            page: payload.query.page,
          })),
          count: response.data.count,
        });
    }
    commit("SET_PAYMENT_SETTING_STATUS", "success");
    return response.message;
  },
  /**
   * Creates an paymentSetting by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the paymentSetting data.
   * @return {Promise<void>} - A promise that resolves when the creation is complete.
   */
  async createPaymentSetting({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.PaymentSetting.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_PAYMENT_SETTING", {
          id: response.data,
          fullNapayTypeme: payload.payType,
          value: payload.value,
          isActive: true,
          page: 1,
        });
      else state.createStatus = "error";
      return true;
    } catch {
      state.createStatus = "error";
    }
  },
  /**
   * Updates an paymentSetting by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the paymentSetting data to update.
   * @param {number} payload.id - The ID of the paymentSetting to be updated.
   * @param {boolean} payload.isActive - Whether the paymentSetting is active or not.
   * @return {Promise<void>} - A promise that resolves when the update is complete.
   */
  async updatePaymentSetting({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const response = await Requests.PaymentSetting.Update(payload, {
        params: { id: payload.id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_PAYMENT_SETTING", payload);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
    } catch {
      state.updateStatus = "error";
    }
  },
  /**
   * Removes an paymentSetting from the state and updates the delete status.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the paymentSetting data.
   * @param {number} payload.id - The ID of the paymentSetting to be removed.
   * @returns {Promise<void>} A promise that resolves when the paymentSetting is successfully removed.
   */
  removePaymentSetting({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.PaymentSetting.Delete({ id })
      .then((response) => {
        state.deleteStatus = response.message === "OK" ? "success" : "error";
      })
      .catch(() => {
        state.deleteStatus = "error";
      });
  },
  /**
   * Retrieves an paymentSetting by their ID and updates the paymentSetting by ID status in the Vuex store.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} id - The ID of the paymentSetting to retrieve.
   * @return {Promise} A promise that resolves when the paymentSetting is successfully retrieved and the status is updated.
   */
  getPaymentSettingById({ commit, state }, { id }) {
    // check if paymentSetting already exists in the state;
    if (
      state.paymentSettingById.data.find(
        (paymentSetting) => paymentSetting.id === id
      )
    )
      return;
    commit("SET_PAYMENT_SETTING_BY_ID_STATUS", "loading");
    return Requests.PaymentSetting.GetById({ params: { id } })
      .then((response) => {
        commit("SET_PAYMENT_SETTING_BY_ID", response.data);
        commit("SET_PAYMENT_SETTING_BY_ID_STATUS", "success");
      })
      .catch(() => {
        commit("SET_PAYMENT_SETTING_BY_ID_STATUS", "error");
      });
  },
};

export default { state, getters, mutations, actions };
